<!--自定义加载动画-->
<template>
  <div class="loading-layer" v-if="isShowLoading" :style="{ background: backgroundStyle }">
    <div class="loading-container">
      <div class="orbit"></div>
      <div class="sphere"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="loading-text" :style="{ color: textStyle }">{{ loadingTxt }}</div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'creatDialog',
  props: {
    isShowLoading () {
      return {
        type: Boolean,
        default: false
      }
    },
    loadingTxt () {
      return {
        type: String,
        default: '加载中'
      }
    },
    backgroundStyle () {
      return {
        type: String,
        default: ''
      }
    },
    textStyle () {
      return {
        type: String,
        default: '#000'
      }
    },
  },
  data () {
    return {

    }
  },
}
</script>
<style lang="less" scoped>
.loading-layer {
  margin: 0;
  width: 100%;
  // height: 100vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: linear-gradient(135deg, #1a1a2e, #16213e);
  overflow: hidden;
  font-family: 'Arial', sans-serif;
  z-index: 2002;
}

.loading-container {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 外圈轨道 */
.orbit {
  position: absolute;
  width: 150px;
  height: 150px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top-color: #0ff;
  border-bottom-color: #f0f;
  animation: spin 2s linear infinite;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5),
    0 0 20px rgba(255, 0, 255, 0.5);
}

.orbit::before {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-left-color: #ff0;
  border-right-color: #0f0;
  animation: spinReverse 3s linear infinite;
  box-shadow: 0 0 10px rgba(255, 255, 0, 0.5),
    0 0 20px rgba(0, 255, 0, 0.5);
}

/* 中心球体 */
.sphere {
  position: relative;
  width: 60px;
  height: 60px;
  background: radial-gradient(circle at 30% 30%,
      #fff,
      #0ff 30%,
      #f0f 60%,
      transparent 80%);
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.8),
    inset 0 0 10px rgba(255, 255, 255, 0.5);
  animation: pulse 2s ease-in-out infinite alternate;
}

/* 漂浮粒子 */
.particle {
  position: absolute;
  width: 8px;
  height: 8px;
  background: linear-gradient(45deg, #0ff, #f0f);
  border-radius: 50%;
  box-shadow: 0 0 5px #0ff, 0 0 10px #f0f;
  animation: float 4s ease-in-out infinite;
}

.particle:nth-child(1) {
  top: 20px;
  left: 20px;
  animation-delay: 0s;
}

.particle:nth-child(2) {
  top: 60px;
  right: 20px;
  animation-delay: 0.5s;
}

.particle:nth-child(3) {
  bottom: 40px;
  left: 40px;
  animation-delay: 1s;
}

.particle:nth-child(4) {
  bottom: 20px;
  right: 30px;
  animation-delay: 1.5s;
}

/* 加载文字 */
.loading-text {
  position: absolute;
  bottom: -40px;
  // color: #fff;
  // color: #000;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 14px;
  // text-shadow: 0 0 5px #0ff;
}

.loading-text::after {
  content: '...';
  position: absolute;
  animation: dots 1.5s steps(5, end) infinite;
}

/* 动画定义 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinReverse {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1.1);
    opacity: 1;
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0) translateX(0);
  }

  25% {
    transform: translateY(-20px) translateX(10px);
  }

  50% {
    transform: translateY(10px) translateX(-10px);
  }

  75% {
    transform: translateY(-10px) translateX(20px);
  }
}

@keyframes dots {

  0%,
  20% {
    content: '.';
  }

  40% {
    content: '..';
  }

  60%,
  100% {
    content: '...';
  }
}
</style>